import { JavaEnum } from '../../../java/lang/JavaEnum';
import { LehrerFachrichtungAnerkennungKatalogEintrag } from '../../../asd/data/lehrer/LehrerFachrichtungAnerkennungKatalogEintrag';
import { CoreTypeDataManager } from '../../../asd/utils/CoreTypeDataManager';
import type { List } from '../../../java/util/List';
import { Class } from '../../../java/lang/Class';
import type { CoreType } from '../../../asd/types/CoreType';
import { de_svws_nrw_asd_types_CoreType_getManager, de_svws_nrw_asd_types_CoreType_daten, de_svws_nrw_asd_types_CoreType_id, de_svws_nrw_asd_types_CoreType_statistikId, de_svws_nrw_asd_types_CoreType_historie } from '../../../asd/types/CoreType';

export class LehrerFachrichtungAnerkennung extends JavaEnum<LehrerFachrichtungAnerkennung> implements CoreType<LehrerFachrichtungAnerkennungKatalogEintrag, LehrerFachrichtungAnerkennung> {

	/** an array containing all values of this enumeration */
	static readonly all_values_by_ordinal: Array<LehrerFachrichtungAnerkennung> = [];

	/** an array containing all values of this enumeration indexed by their name*/
	static readonly all_values_by_name: Map<string, LehrerFachrichtungAnerkennung> = new Map<string, LehrerFachrichtungAnerkennung>();

	/**
	 * Fachrichtungsanerkennung 'erworben durch LABG/OVP bzw. Laufbahnverordnung'
	 */
	public static readonly ID4: LehrerFachrichtungAnerkennung = new LehrerFachrichtungAnerkennung("ID4", 0, );

	/**
	 * Fachrichtungsanerkennung 'Unterrichtserlaubnis (z. B. Zertifikatskurs)'
	 */
	public static readonly ID5: LehrerFachrichtungAnerkennung = new LehrerFachrichtungAnerkennung("ID5", 1, );

	/**
	 * Fachrichtungsanerkennung 'mehrjähriger Unterricht ohne Lehramtsprüfung oder Unterrichtserlaubnis'
	 */
	public static readonly ID6: LehrerFachrichtungAnerkennung = new LehrerFachrichtungAnerkennung("ID6", 2, );

	/**
	 * Fachrichtungsanerkennung 'sonstige'
	 */
	public static readonly ID7: LehrerFachrichtungAnerkennung = new LehrerFachrichtungAnerkennung("ID7", 3, );

	private constructor(name: string, ordinal: number) {
		super(name, ordinal);
		LehrerFachrichtungAnerkennung.all_values_by_ordinal.push(this);
		LehrerFachrichtungAnerkennung.all_values_by_name.set(name, this);
	}

	/**
	 * Initialisiert den Core-Type mit dem angegebenen Manager.
	 *
	 * @param manager   der Manager für die Daten des Core-Types
	 */
	public static init(manager: CoreTypeDataManager<LehrerFachrichtungAnerkennungKatalogEintrag, LehrerFachrichtungAnerkennung>): void {
		CoreTypeDataManager.putManager(LehrerFachrichtungAnerkennung.class, manager);
	}

	/**
	 * Gibt den Daten-Manager für den Zugriff auf die Core-Type-Daten zurück, sofern dieser initialisiert wurde.
	 *
	 * @return der Daten-Manager
	 */
	public static data(): CoreTypeDataManager<LehrerFachrichtungAnerkennungKatalogEintrag, LehrerFachrichtungAnerkennung> {
		return CoreTypeDataManager.getManager(LehrerFachrichtungAnerkennung.class);
	}

	/**
	 * Returns an array with enumeration values.
	 *
	 * @returns the array with enumeration values
	 */
	public static values(): Array<LehrerFachrichtungAnerkennung> {
		return [...this.all_values_by_ordinal];
	}

	/**
	 * Returns the enumeration value with the specified name.
	 *
	 * @param name   the name of the enumeration value
	 *
	 * @returns the enumeration values or null
	 */
	public static valueOf(name: string): LehrerFachrichtungAnerkennung | null {
		const tmp = this.all_values_by_name.get(name);
		return (!tmp) ? null : tmp;
	}

	public getManager(): CoreTypeDataManager<LehrerFachrichtungAnerkennungKatalogEintrag, LehrerFachrichtungAnerkennung> {
		return de_svws_nrw_asd_types_CoreType_getManager(this);
	}

	public daten(schuljahr: number): LehrerFachrichtungAnerkennungKatalogEintrag | null {
		return de_svws_nrw_asd_types_CoreType_daten(this, schuljahr);
	}

	public id(schuljahr: number): number | null {
		return de_svws_nrw_asd_types_CoreType_id(this, schuljahr);
	}

	public statistikId(): string | null {
		return de_svws_nrw_asd_types_CoreType_statistikId(this);
	}

	public historie(): List<LehrerFachrichtungAnerkennungKatalogEintrag> {
		return de_svws_nrw_asd_types_CoreType_historie(this);
	}

	transpilerCanonicalName(): string {
		return 'de.svws_nrw.asd.types.lehrer.LehrerFachrichtungAnerkennung';
	}

	isTranspiledInstanceOf(name: string): boolean {
		return ['de.svws_nrw.asd.types.lehrer.LehrerFachrichtungAnerkennung', 'de.svws_nrw.asd.types.CoreType', 'java.lang.Comparable', 'java.lang.Enum', 'java.lang.Comparable'].includes(name);
	}

	public static readonly class = new Class<LehrerFachrichtungAnerkennung>('de.svws_nrw.asd.types.lehrer.LehrerFachrichtungAnerkennung');

}

export function cast_de_svws_nrw_asd_types_lehrer_LehrerFachrichtungAnerkennung(obj: unknown): LehrerFachrichtungAnerkennung {
	return obj as LehrerFachrichtungAnerkennung;
}
